import styled from 'styled-components';

export const DivWrapper = styled.div`
  padding: 30px 50px;
`;
